module.exports = __webpack_public_path__ + "static/media/tabs.cd2830fd.css";